const offer_cta_btns = document.getElementsByClassName("get-offer-cta-button");
const offer_cta_btns_array = Array.from(offer_cta_btns);

offer_cta_btns_array.forEach(function (btn) {
  btn.addEventListener('click', function(e) {

    e.preventDefault(); 
    openOfferForm('request-for-quotation', 'open-offer-form-button');

  });
});

const home_visit_cta_btns = document.getElementsByClassName("book-home-visit-cta-button");
const home_visit_cta_btns_array = Array.from(home_visit_cta_btns);

home_visit_cta_btns_array.forEach(function (btn) {
  btn.addEventListener('click', function(e) {

    e.preventDefault(); 
    openOfferForm('request-for-quotation-home-visit', 'open-offer-home-visit-form-button');

  });
});

function openOfferForm( formId, buttonId ) {
  const targetElement = document.getElementById(formId);
  if (targetElement) {

      targetElement.scrollIntoView({
        behavior: 'smooth'
      });

      setTimeout(function () {
        // Check if already expanded
        if (document.querySelector("#" + formId + " #offer-form-container").style.display === "block") {
          return;
        }
        const button = document.getElementById(buttonId);
        if (button) {
          button.click();
        }
      }, 800); 

  }
}